export const i18nDefaults = {
  "pt.enum.none": "Nenhum",
  "pt.enum.placeholder": "Selecione um valor",
  "pt.oneofenum.placeholder": "Selecione um ou mais valores",
  "pt.stepper.previous": "Anterior",
  "pt.stepper.next": "Seguinte",
  "en": {    
    "yes": "yes",
    "no": "no",
    "confirmation": "Confirmação",
    "noPhotosInfo": "There are no photos. You can add them by clicking the 'Add photo' button.",
    "noFilesInfo": "There are no files. You can add them by clicking the 'Add file' button.",
    "addPhoto": "Add photo",
    "addFile": "Add file",
    "deletePhoto": "Delete photo",
    "editPhoto": "Edit photo",
    "deleteFile": "Delete file",
    "editFile": "Edit file",
    "deleteFileConfirmation": "Do you want to delete the file",    
    "photo": "Photo",
    "photos": "Photos",
    "file": "File",
    "files": "Files",
    "controls": {
      "close": "Close",
      "save": "Save",
      "photo": "Photo",
      "file": "File",
      "size": "Size",
      "newfile": "New file",
      "choose": "Choose",
      "upload": "Upload",
      "cancel": "Cancel",
      "maxFileSize": "Max file size",
      "addFileRequired": "You need to add a file."
    },    
    "error":{
      "required":"field is required",
      "pattern": "invalid format",
      "oneOf": "must match exactly one schema in oneOf",
      "const": "must be equal to constant",
      "enum": "must be equal to one of the allowed values"
    },
  },
  "pt": {
    "yes": "Sim",
    "no": "Não",
    "confirmation": "Confirmation",
    "noPhotosInfo": "Não existem fotografias. Pode adicioná-las através do botão 'Adicionar fotografia'.",
    "noFilesInfo": "Não existem ficheiros. Pode adicioná-las através do botão 'Adicionar ficheiro'.",
    "addPhoto": "Adicionar fotografia",
    "addFile": "Adicionar ficheiro",
    "deletePhoto": "Eliminar fotografia",
    "editPhoto": "Editar fotografia",
    "deleteFile": "Eliminar ficheiro",
    "editFile": "Editar ficheiro",
    "deleteFileConfirmation": "Deseja eliminar o ficheiro",    
    "photo": "Fotografia",
    "photos": "Fotografias",
    "file": "Ficheiro",
    "files": "Ficheiros",
    "controls": {
      "close": "Fechar",
      "save": "Gravar",  
      "photo": "Fotografia",
      "file": "Ficheiro",
      "size": "Dimensão",
      "newfile": "Novo ficheiro",
      "choose": "Escolher",
      "upload": "Carregar",
      "cancel": "cancelar",
      "maxFileSize": "Dimensão máxima do ficheiro",
      "addFileRequired": "É necessário adicionar um ficheiro."
    },
    "error":{
      "required": "Campo obrigatório",
      "pattern": "Formato inválido",
      "oneOf": "Deve corresponder a um dos valores da permitidos",
      "const": "Deve ser igual à constante",
      "enum": "Deve corresponder a um dos valores permitidos"
    }
  }
}